import clsx from 'clsx';

export const SvgPause = ({ className, handleClick }) => (
  <button
    className={clsx('group absolute cursor-pointer', className)}
    onClick={handleClick}
  >
    <svg
      enableBackground="new 0 0 40 40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>pause video button</title>
      <path
        id="pause-button-path"
        className="fill-parlor-green-80 group-hover:fill-parlor-green transition duration-500 ease-in-out"
        d="m20 0c11 0 20 9 20 20 0 11-9 20-20 20-11 0-20-9-20-20 0-11 9-20 20-20z"
      ></path>
      <path
        d="m21.7 14.2v11.6.8c.1.7.7 1.3 1.3 1.4h.8.8c.7-.1 1.2-.7 1.3-1.4 0-.2 0-.4 0-.8v-11.6c0-.4 0-.6 0-.8-.1-.7-.7-1.3-1.3-1.4-.2 0-.4 0-.8 0s-.6 0-.8 0c-.7.1-1.2.7-1.3 1.4zm-7.7 0v11.6.8c.1.7.7 1.3 1.3 1.4h.8.8c.7-.1 1.2-.7 1.3-1.4 0-.2 0-.4 0-.8v-11.6c0-.4 0-.6 0-.8-.1-.7-.7-1.3-1.3-1.4-.2 0-.4 0-.8 0s-.6 0-.8 0c-.7.1-1.2.7-1.3 1.4z"
        fill="#fff"
      ></path>
    </svg>
  </button>
);
